import { render, staticRenderFns } from "./BudgetDetails.vue?vue&type=template&id=e42195a2&scoped=true"
import script from "./BudgetDetails.vue?vue&type=script&lang=js"
export * from "./BudgetDetails.vue?vue&type=script&lang=js"
import style0 from "./BudgetDetails.vue?vue&type=style&index=0&id=e42195a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42195a2",
  null
  
)

export default component.exports